import type { FC, ReactNode } from 'react';

// Externals
import PropTypes from 'prop-types';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

// Store
import { useSelector } from '../store';

interface PayoutManagerGuardProps {
  children: ReactNode;
}

const PayoutManagerGuard: FC<PayoutManagerGuardProps> = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const isAuthenticated = useSelector<boolean>((state) => state.authentication.isAuthenticated);
  const isPayoutManager = useSelector<boolean>((state) => state.authentication.isPayoutManager);

  if (!isAuthenticated) {
    return <Navigate replace={true} to={`/login?redirect=${encodeURIComponent(location.pathname)}`} />;
  }

  if (!isPayoutManager) {
    return <Navigate replace={true} to={`/401`} />;
  }

  // This is done so that in case the route changes by any chance through other
  // means between the moment of request and the render we navigate to the initially
  // requested route.
  if (searchParams.get('redirect') && location.pathname !== searchParams.get('redirect')) {
    return <Navigate replace={true} to={searchParams.get('redirect')} />;
  }

  return <>{children}</>;
};

PayoutManagerGuard.propTypes = {
  children: PropTypes.node
};

export default PayoutManagerGuard;
